/**
 * HALO - Dashboard Layout
 * Wraps all authenticated pages with sidebar + header.
 */

import { Outlet } from "react-router-dom";
import { AppSidebar, SidebarProvider } from "@/components/layout/AppSidebar";
import { SiteHeader } from "@/components/layout/SiteHeader";
import ErrorNotification from "@/components/ErrorNotification";

interface DashboardLayoutProps {
  userRole: "admin" | "manager" | "employee";
  userName: string;
  userEmail: string;
  orgName?: string;
  onLogout: () => void;
}

export function DashboardLayout({
  userRole,
  userName,
  userEmail,
  orgName,
  onLogout,
}: DashboardLayoutProps) {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full bg-background overflow-hidden">
        <AppSidebar
          userRole={userRole}
          userName={userName}
          userEmail={userEmail}
          orgName={orgName}
          onLogout={onLogout}
        />
        <div className="flex flex-1 flex-col min-w-0 overflow-hidden">
          <SiteHeader />
          <main className="flex-1 overflow-y-auto custom-scrollbar">
            <Outlet />
          </main>
        </div>
      </div>
      <ErrorNotification />
    </SidebarProvider>
  );
}
